// src/ConsumerApp/Screens/Account/components/OrderBillSummaryCard.js

import React from 'react';

export default function OrderBillSummaryCard({ order }) {
  if (!order) return null;

  const subtotal = Number(order.subtotal || order.total || 0);
  const discount = Number(order.discount || 0);
  const brick_points_redeemed = Number(order.brick_points_redeemed || 0);
  const tax = Number(order.tax_amount || 0);
  const delivery = order.delivery_charges;
  const unloading = Number(order.unloading_charges || 0);
  const total = Number(order.total || 0);

  return (
    <div style={styles.summaryCard}>
      <h3 style={styles.summaryTitle}>Bill Summary</h3>

      <div style={styles.summaryRow}>
        <span>Sub total</span>
        <span style={{ fontWeight: '600' }}>₹{subtotal.toLocaleString('en-IN')}</span>
      </div>

      {discount > 0 && (
        <div style={styles.summaryRow}>
          <span>Discount</span>
          <span style={{ color: '#1E8449', fontWeight: '600' }}>- ₹{discount}</span>
        </div>
      )}

      {brick_points_redeemed > 0 && (
        <div style={styles.summaryRow}>
          <span>Brick Points Redeemed</span>
          <span style={{ color: '#1E8449', fontWeight: '600' }}>- ₹{brick_points_redeemed}</span>
        </div>
      )}

      {tax > 0 && (
        <div style={styles.summaryRow}>
          <span>Taxes</span>
          <span style={{ fontWeight: '600' }}>₹{tax}</span>
        </div>
      )}

      {delivery != null && (
        <div style={styles.summaryRow}>
          <span>Delivery Charges</span>
          {delivery === 0 ? (
            <span style={{ fontWeight: '600', color: '#1E8449' }}>Free</span>
          ) : (
            <span style={{ fontWeight: '600' }}>₹{delivery}</span>
          )}
        </div>
      )}

      {unloading > 0 && (
        <div style={styles.summaryRow}>
          <span>Unloading Charges</span>
          <span style={{ fontWeight: '600' }}>₹{unloading}</span>
        </div>
      )}

      <div style={styles.receiptDivider} />

      <div style={{ ...styles.summaryRow, marginBottom: 0, fontSize: 16 }}>
        <strong>Total</strong>
        <strong>₹{total.toLocaleString('en-IN')}</strong>
      </div>
    </div>
  );
}

const styles = {
  summaryCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    border: '1px solid #CBD5E1',
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  summaryTitle: { fontSize: 14, fontWeight: '700', color: '#2B2A29', margin: '0 0 4px 0' },
  summaryRow: { display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#2B2A29' },
  receiptDivider: { height: 1, backgroundColor: '#CBD5E1', margin: '6px 0' },
};